// src/useTranslate.ts
import useTranslation from "next-translate/useTranslation";

// src/plural.ts
var getPluralDefaultValue = (defaultValues, count) => {
  if (count === 0) {
    return defaultValues.zero ?? defaultValues.other;
  }
  if (count === 1) {
    return defaultValues.one;
  }
  return defaultValues.other;
};

// src/useTranslate.ts
var useTranslate = (namespace) => {
  const { t } = useTranslation(namespace);
  function customT(key, defaultValues, variables) {
    if (typeof defaultValues === "string") {
      return t(key, variables, { default: defaultValues });
    }
    const defaultValue = getPluralDefaultValue(
      defaultValues,
      variables == null ? void 0 : variables.count
    );
    return t(key, variables, { default: defaultValue });
  }
  return customT;
};

// src/Trans.tsx
import TTrans from "next-translate/Trans";
import React from "react";
var isPluralProps = (props) => {
  return props.defaultTrans !== "string";
};
var Trans = (props) => {
  const defaultTrans = isPluralProps(props) ? getPluralDefaultValue(props.defaultTrans, props.values.count) : props.defaultTrans;
  return /* @__PURE__ */ React.createElement(
    TTrans,
    {
      i18nKey: props.i18nKey,
      ns: props.ns,
      components: props.components,
      defaultTrans,
      values: props.values
    }
  );
};
export {
  Trans,
  useTranslate
};
